import { render } from "./NewProject.vue?vue&type=template&id=0b97a2f7&scoped=true"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"

import "./NewProject.vue?vue&type=style&index=0&id=0b97a2f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b97a2f7"

export default script